<div class="fb-container" #fbContainer>
  <a
    [attr.href]="chartUrl"
    class="text-underline"
    target="_blank"
    *ngIf="shouldAddLink">
    {{ content }}
  </a>
  <span class="fb-content" *ngIf="!shouldAddLink">
    {{ content }}
  </span>
</div>
